import { render, staticRenderFns } from "./UserMessageCountCell.vue?vue&type=template&id=f4369e88&scoped=true&"
import script from "./UserMessageCountCell.vue?vue&type=script&lang=babel&"
export * from "./UserMessageCountCell.vue?vue&type=script&lang=babel&"
import style0 from "./UserMessageCountCell.vue?vue&type=style&index=0&id=f4369e88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4369e88",
  null
  
)

export default component.exports